module.exports = __webpack_public_path__ + "8294256851d6e59ed8bdf3037a3393d1.MP3";